import { PillProps } from '@common/types';
import React from 'react';
import Pill from './Pill';

interface Props {
  primaryPill?: PillProps;
  secondaryPill?: PillProps;
  promoPill?: PillProps;
}

export default ({ primaryPill, secondaryPill, promoPill }: Props) => {
  return primaryPill || secondaryPill || promoPill ? (
    <div className='tour__header-info-holder'>
      <div className='row m-0'>
        <div className='col-6 p-0'>
          {promoPill ? (
            <Pill
              icon={promoPill.icon}
              text={promoPill.text}
              class='tour__header-info--red'
            />
          ) : null}
          {primaryPill ? (
            <Pill
              icon={primaryPill.icon}
              text={primaryPill.text}
              class='tour__header-info--blue'
            />
          ) : null}
          {secondaryPill ? (
            <Pill
              icon={secondaryPill.icon}
              text={secondaryPill.text}
              class='tour__header-info--orange'
            />
          ) : null}
        </div>
      </div>
    </div>
  ) : null;
};
